import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SETTINGS } from '../config/common.settings';

export interface SaleItem {
  itemId: string;
  itemName: string;
  quantity: number;
  price: number;
}

export interface Sale {
  _id?: string;
  date: string; // ISO string
  items: SaleItem[];
  price: number;
  paymentMethod: string;
}

@Injectable({
  providedIn: 'root',
})
export class SalesService {
  constructor(private http: HttpClient) {}

  // Get all sales
  getAllSales(): Promise<Sale[]> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/sales/get-all`).subscribe({
        next: (response: any) => resolve(response?.data || []),
        error: (error: any) => reject(error.error || error),
      });
    });
  }

  // Get a single sale
  getSale(id: string): Promise<Sale | null> {
    return new Promise((resolve, reject) => {
      this.http.get(`${SETTINGS.BASE_API}/sales/${id}`).subscribe({
        next: (response: any) => resolve(response?.data || null),
        error: (error: any) => reject(error.error || error),
      });
    });
  }

  // Create a new sale
  createSale(payload: Sale): Promise<Sale> {
    return new Promise((resolve, reject) => {
      this.http.post(`${SETTINGS.BASE_API}/sales/create`, payload).subscribe({
        next: (response: any) => resolve(response?.data),
        error: (error: any) => reject(error.error || error),
      });
    });
  }

  // Update an existing sale
  updateSale(id: string, payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http.put(`${SETTINGS.BASE_API}/sales/${id}`, payload).subscribe({
        next: (response: any) => resolve(response),
        error: (error: any) => reject(error.error || error),
      });
    });
  }
}
